import { employeesInterface, equipmentInterface, gendersInterface } from '../common/interfaces'

export const genders: Array<gendersInterface> = [
    { label: 'Male', value: 'male'},
    { label: 'Female', value: 'female'},
    { label: 'Other', value: 'other'}
];

export const roles: Array<string> = [
    'Registered Nurse',
    'Continence Nurse Advisor',
    'Clinical Nurse Consultant',
    'OT/Physiotherapist',
    'Other Clinician',
    'Support Coordinator',
    'Carer',
    'Client',
    'Other'
];

export const states: Array<string> = [
    'NSW',
    'VIC',
    'QLD',
    'TAS',
    'SA',
    'NT',
    'ACT',
    'WA'
]

export const statesWithAM: Array<string> = [
    'NSW (AM: Damian Anderson 11001631)',
    'VIC (AM: Breda O’Hara 00045558)',
    'QLD (AM: Chris Towers 11001886)',
    'TAS (AM: Breda O’Hara 00045558)',
    'SA (AM: Breda O’Hara 00045558)',
    'NT (AM: Chris Towers 11001886)',
    'WA (AM: Damian Anderson 11001631)'
]

export const bladderControlPads: Array<string> = [
    'BCPE01 - Contour Plus Moderate',
    'BCPE02 - Contour Plus Maximum',
    'BCPE03 - Contour Plus Ultimate',
    'MSCMG02AUS - Fitright Active Male Guard'
];

export const excludedJsonAttributes: Array<string> = [
    'firstName',
    'lastName',
    'email',
    'roleselected',
    'organisation',
    'state',
    'shipfirstName',
    'shiplastName',
    'Address1',
    'Address2',
    'city',
    'shipstate',
    'postcode',
    'phone',
    'notification',
    'reqnotification',
    'trackingemail',
    'comments',
    'authtoleave'
]
